import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/submitted-review.png'


const _withScopeId = n => (_pushScopeId("data-v-3e85431d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column w-100 align-items-center submitted-review-container" }
const _hoisted_2 = {
  class: "d-flex align-items-center justify-space-between",
  style: {"padding-left":"46px","padding-right":"59px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { style: {"margin-left":"14px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center title" }, " Successfully submitted tenant reference ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center sub-title" }, "Take a look at the tenant profile", -1))
const _hoisted_7 = { class: "link w-100 d-flex align-items-center justify-content-between" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  class: "d-flex flex-column w-100",
  style: {"padding-left":"113px","padding-right":"59px","margin-top":"52px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin-bottom":"4px"},
  class: "form-text"
}, " Send the tenant reference to the following emails: ", -1))
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  class: "d-flex justify-content-center",
  style: {"margin-top":"37px"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Back To Home")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_tag = _resolveComponent("input-tag")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: _ctx.link,
            class: "text-truncate"
          }, _toDisplayString(_ctx.link), 9, _hoisted_8),
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args))),
            style: {"color":"#7b7b7b"},
            class: "fa fa-clone cursor-pointer"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_input_tag, {
          separators: [','],
          regex: _ctx.emailValidRegex,
          unique: true,
          modelValue: _ctx.emails,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.emails) = $event)),
          color: "#F7ECFA",
          "text-color": "#990ABD",
          placeholder: "Add the emails here ..."
        }, null, 8, ["regex", "modelValue"]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickSendReviewToEmails && _ctx.clickSendReviewToEmails(...args))),
          disabled: _ctx.isSendingEmail,
          class: "btn btn-lg btn-new-design-primary",
          style: {"margin-left":"36px"}
        }, " Send ", 8, _hoisted_12)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('new'))),
        class: "btn btn-lg btn-new-design-primary",
        style: {"margin-left":"36px"}
      }, " Submit Another Tenant Reference "),
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "btn btn-lg btn-new-design-secondary",
        style: {"margin-left":"36px"}
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      })
    ])
  ]))
}